import { render, staticRenderFns } from "./PreCo.vue?vue&type=template&id=13d8aaa6&"
import script from "./PreCo.vue?vue&type=script&lang=ts&"
export * from "./PreCo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports